module.exports = __webpack_public_path__ + "img/decor-right.b7649ce7.png";